// Asset load_type options; id is the stored load_type (StateOptions LoadTypes), value is the Dropdown key.
export const loadTypes = [
    {
        id: 0,
        title: 'Consumption Only',
        value: 'CONSUMPTION'
    },
    {
        id: 1,
        title: 'Generation Only',
        value: 'GENERATION'
    },
    {
        id: 2,
        title: 'Consumption and Export',
        value: 'EXPORT'
    },
];
